import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { AddRequestTechnicalSupportDrawerModalWithoutMachine } from "@src/components/organisms/modals/add-request-technical-support-drawer-modal-without-machine/add-request-technical-support-drawer-modal-without-machine";

export const AddRequestTechnicalSupportDrawerWithoutMachine = () => {
  const showModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.addRequestTechnicalSupportDrawerModalWithoutMachine
        .showModal,
  );
  return (
    <>{showModal && <AddRequestTechnicalSupportDrawerModalWithoutMachine />}</>
  );
};
